module.exports = "<div class=\"checkbox-container\">\n    <input class=\"gw-no-label\" type=\"checkbox\" ng-model=\"model\">\n    <label ng-click=\"toggleCheckbox()\">\n            <span class=\"label-text\">\n                {{ labelText }}\n                <a *ngIf=\"linkText\" class=\"textlink\" target=\"_blank\" href=\"{{linkHref}}\">{{ linkText }}</a>\n            </span>\n    </label>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../common/grunt/webpack/loaders/text-loader!../common/js/src/edge/platform/basler/templates/basler-checkbox.html
// module id = 562
// module chunks = 0